export default "__VITE_ASSET__0e834beb__"